import React from 'react';
import { JobEscalation, Team } from './types';
import { FilterOptions } from './TaskFilters.styles';
import { getJobTypesForTeam } from './teamJobLookup';
import { ClientIdsFilter } from './task-filters/ClientIdsFilter';
import { AssigneeFilter } from './task-filters/AssigneeFilter';
import { TeamFilter } from './task-filters/TeamFilter';
import { JobFilter } from './task-filters/JobFilter';
import { TaskFilter } from './task-filters/TaskFilter';
import { InboxTypeFilter } from './task-filters/InboxTypeFilter';
import { EscalatedFilter } from './task-filters/EscalatedFilter';
import { StatusFilter } from './task-filters/StatusFilter';
import { BookkeepingIdsFilter } from './task-filters/BookkeepingIdsFilter';
import { useQueryParamsWithDefaults } from './useQueryParamsWithDefaults';

type TaskFiltersProps = {
  isBpaView?: boolean;
  isClientsTaskManager?: boolean;
  requireTeam?: boolean;
};

const TaskFilters = ({
  isBpaView = false,
  isClientsTaskManager = false,
  requireTeam = false,
}: TaskFiltersProps) => {
  const { query, setQuery } = useQueryParamsWithDefaults(isBpaView, requireTeam);
  const { team } = query;

  const handleSelectChange = (value, name) => {
    const updatedValue = name !== 'status' && value === 'All' ? undefined : value;
    const updatedFilters = {
      ...query,
      [name]: updatedValue,
    };
    if (name === 'team') {
      updatedFilters.jobTypes = getJobTypesForTeam(value);
      updatedFilters.taskTypes = undefined;
    } else if (name === 'jobTypes') {
      if (value === 'All') {
        updatedFilters.jobTypes = team ? getJobTypesForTeam(Team[team]) : undefined;
      }
      updatedFilters.taskTypes = undefined;
    } else if (name === 'isEscalated') {
      if (value === JobEscalation.ESCALATED) {
        updatedFilters.isEscalated = true;
      } else if (value === JobEscalation.NON_ESCALATED) {
        updatedFilters.isEscalated = false;
      }
    }
    setQuery(updatedFilters, 'pushIn');
  };

  const assigneeFilter = (
    <AssigneeFilter key="assigneeFilter" handleSelectChange={handleSelectChange} />
  );

  const teamFilter = (
    <TeamFilter
      key="teamFilter"
      showAllOption={isBpaView || isClientsTaskManager}
      handleSelectChange={handleSelectChange}
    />
  );

  const jobFilter = <JobFilter key="jobFilter" handleSelectChange={handleSelectChange} />;

  const taskFilter = <TaskFilter key="taskFilter" handleSelectChange={handleSelectChange} />;

  const inboxTypeFilter = (
    <InboxTypeFilter key="inboxTypeFilter" handleSelectChange={handleSelectChange} />
  );

  const escalatedFilter = (
    <EscalatedFilter key="escalatedFilter" handleSelectChange={handleSelectChange} />
  );

  const statusFilter = <StatusFilter key="statusFilter" handleSelectChange={handleSelectChange} />;

  const clientIdsFilter = <ClientIdsFilter key="clientIdsFilter" />;

  const bookkeeperIdsFilter = <BookkeepingIdsFilter key="bookkeeperIdsFilter" />;

  let filterDropdowns;
  if (isBpaView) {
    filterDropdowns = [teamFilter, inboxTypeFilter, escalatedFilter, statusFilter, clientIdsFilter];
  } else if (isClientsTaskManager) {
    filterDropdowns = [teamFilter, statusFilter, escalatedFilter, jobFilter, taskFilter];
  } else {
    filterDropdowns = [
      assigneeFilter,
      teamFilter,
      jobFilter,
      taskFilter,
      inboxTypeFilter,
      escalatedFilter,
      statusFilter,
      clientIdsFilter,
      bookkeeperIdsFilter,
    ];
  }

  return <FilterOptions aria-label="task table filters">{filterDropdowns}</FilterOptions>;
};

export default TaskFilters;
